import axios from 'axios';

export default {

    //Ping le serveur
    ping() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/ping');
    }
}
